export const lightbox = () => {
    require("fslightbox");
}